import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import {
  INotification,
  IProviderConsumers,
  IProviderState,
  IProviderProps,
} from "./_notification.types";
import { v4 as uuid } from "uuid";
import { OptionsObject, SnackbarProvider, useSnackbar } from "notistack";
import { useEffect } from "react";

const Context = createContext<any>(null);

const initialState: IProviderState = {
  notifications: [],
};

const Provider = (props: IProviderProps) => {
  const { children } = props;

  const [state, setState] = useState<IProviderState>(initialState);

  const handleShowNotification = useCallback((notification: INotification) => {
    setState((prev) => ({
      ...prev,
      notifications: [...prev.notifications, notification],
    }));
  }, []);

  return (
    <Context.Provider
      value={{
        ...state,
        handleShowNotification,
      }}
    >
      <SnackbarProvider maxSnack={5}>
        <NotificationSnackbar>{children}</NotificationSnackbar>
      </SnackbarProvider>
    </Context.Provider>
  );
};

const NotificationSnackbar = (props: { children: ReactNode }) => {
  const { notifications } = useContext<IProviderConsumers>(Context);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (notifications?.length) {
      const last = notifications[notifications.length - 1];
      if (last.message) {
        const message: OptionsObject = {
          key: uuid(),
          variant: last?.type || "default",
          autoHideDuration: last?.time || 3500,
          anchorOrigin: {
            horizontal: "left",
            vertical: "bottom",
          },
        };
        enqueueSnackbar(last.message, message);
      }
    }
  }, [notifications, enqueueSnackbar]);

  return <>{props.children}</>;
};

export const useNotification = () => useContext<IProviderConsumers>(Context);
export default Provider;
